import { GaugeData } from '@quality24/design-system';

import { GaugeChartComponentData } from '../../../../@types';
import { sanitizeKey } from '../../../../utils/dataUtils';

/**
 * Maps the data to a gauge chart in the format:
 *
 * [{ id: aggrKey.id, value: groupBy[1].id, label: groupBy[2].id }]
 */
export const formatChartData = (
  aggrKey: GaugeChartComponentData['aggrKey'],
  data: Array<Record<string, string | number>>,
  keys: Array<string>,
): Array<GaugeData> => {
  const labelKey = sanitizeKey(aggrKey.key);
  const [valueKey, ...otherKeys] = keys;
  return data.map<GaugeData>((d) => ({
    id: `${d[labelKey]}`,
    // eslint-disable-next-line no-underscore-dangle
    value: d._original ? (d[valueKey] as number) : null,
    ...otherKeys.reduce((acc, k) => {
      // eslint-disable-next-line no-underscore-dangle
      acc[k] = d._original ? d[k] : '-';
      return acc;
    }, {} as Record<string, string | number>),
  }));
};

/**
 * Returns a list of all keys in the mapped object to use in the chart
 * @param groupBy
 * @returns
 */
export const getAdditionalChartKeys = (
  groupBy: GaugeChartComponentData['groupBy'],
): Array<string> => {
  // For single dataset charts, there is no additional chart key
  if (groupBy.length < 2) return [];

  // For multiple dataset charts, the `compl` key is in the second position
  const [, ...keyGroups] = groupBy;
  return keyGroups.map((keyGroup) => sanitizeKey(keyGroup.key));
};
